


































































import { UPDATE_MENU_TYPE } from "@/queries/user/mutation.graphql";
import { GET_MENU, GET_MENU_TYPE } from "@/queries/user/query.graphql";
import { bus } from "@/utils/event-emitter";
import Vue from "vue";
export default Vue.extend({
  props: {
    fromModal: {
      type: Boolean
    }
  },
  data() {
    return {
      pdf: null,
      menuId: null,
      isSwitching: false,
      menuType: null
    };
  },
  methods: {
    async switchType(type) {
      this.isSwitching = true;
      const { errors, data } = await this.updatePDF(this.pdf, type);
      this.isSwitching = false;
    },
    getName(url) {
      if (!url) return "";
      const arr = url.split("-");
      return arr[arr.length - 1];
    },
    removePDF(e) {
      this.updatePDF("", "ONLINE");
    },
    async updatePDF(pdfUrl, menuType = "PDF") {
      const { data, errors } = await this.$apollo.mutate({
        mutation: UPDATE_MENU_TYPE,
        variables: {
          menuId: this.menuId,
          pdfUrl,
          menuType
        },
        update: (cache, { data: { update_Menu } }) => {
          if (update_Menu.affected_rows) {
            const menuTypeObj: any = cache.readQuery({
              query: GET_MENU_TYPE
            });
            // menuType.Menu[0].menuType = menuType;
            // menuType.Menu[0].pdfUrl = pdfUrl;
            menuTypeObj.Menu[0] = {
              ...menuTypeObj.Menu[0],
              menuType,
              pdfUrl
            };
            cache.writeQuery({
              query: GET_MENU_TYPE,
              data: menuTypeObj
            });
          }
        }
      });

      if (data) {
        this.pdf = pdfUrl;
        if (menuType === "ONLINE") {
          this.$router.push({ name: "menu" });
        } else {
          this.$router.push({ name: "pdf" });
        }
        if (this.fromModal) {
          this.$emit("close");
        }
      }
      return {
        data,
        errors
      };
    }
  },
  async created() {
    bus.$on("switchMenuType", e => {
      this.switchType("ONLINE");
    });
    const { data } = await this.$apollo.query({
      query: GET_MENU_TYPE
    });
    if (data) {
      this.pdf = data.Menu[0].pdfUrl;
      this.menuId = data.Menu[0].id;
      this.menuType = data.Menu[0].menuType;
    }
  }
});
